package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface GuideEnvironment : Environment {
    val wfpHost: String
    val wlstHost: String
    val wfpPath: String
    val wlstPath: String
    val apiKey: String
}

@JsExport
abstract class BaseGuideEnvironment(override val wfpPath: String = "api", override val wlstPath: String = "v1/watchlist") : GuideEnvironment

@JsExport
data class StageGuideEnvironment(
    override val wfpHost: String = "watchfreeplus-epg-stage.smartcasttv.com",
    override val wlstHost: String = "watchlist-stage.smartcasttv.com",
    override val apiKey: String
) : BaseGuideEnvironment()

@JsExport
data class ProdGuideEnvironment(
    override val wfpHost: String = "watchfreeplus-epg-prod.smartcasttv.com",
    override val wlstHost: String = "watchlist-prod.smartcasttv.com",
    override val apiKey: String
) : BaseGuideEnvironment()

fun chooseGuideEnvironment(envConfig: GuideEnvironmentConfig): GuideEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdGuideEnvironment(apiKey = envConfig.apiKey)
        EnvironmentGroup.PREPROD -> TODO("PreProdGuideEnvironment() is not defined")
        EnvironmentGroup.STAGE -> StageGuideEnvironment(apiKey = envConfig.apiKey)
        EnvironmentGroup.DEV -> TODO("DevGuideEnvironment() is not defined")
        EnvironmentGroup.TEST -> TODO("TestGuideEnvironment() is not defined")
    }
}